import React from "react";

export const PageHero = ({ eyebrow, title, italicTail, intro, dark = false }) => (
  <section
    className={`relative overflow-hidden ${dark ? "bg-[#0A3B3B] text-white" : "bg-[#F7FAF9] text-[#0A2424]"} pt-20 pb-16 md:pt-28 md:pb-20`}
  >
    <div className={`absolute inset-0 pointer-events-none ${dark ? "bg-kente opacity-[0.12]" : "bg-sunburst"}`} />
    <div className={`absolute -top-24 -left-24 h-[420px] w-[420px] rounded-full blur-3xl pointer-events-none ${dark ? "bg-[#0E6B6B]/40" : "bg-[#0E6B6B]/8"}`} />
    <div className={`absolute -bottom-32 right-0 h-[380px] w-[380px] rounded-full blur-3xl pointer-events-none ${dark ? "bg-[#D96C4A]/20" : "bg-[#D96C4A]/10"}`} />

    <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          {eyebrow && (
            <span className={`text-xs md:text-sm tracking-[0.2em] uppercase font-bold ${dark ? "text-[#FFD8A8]" : "text-[#D96C4A]"}`}>
              {eyebrow}
            </span>
          )}
          <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
            {title}{" "}
            {italicTail && (
              <span className={`italic ${dark ? "text-[#FFD8A8]" : "text-[#0E6B6B]"}`}>
                {italicTail}
              </span>
            )}
          </h1>
        </div>
        {intro && (
          <div className="lg:col-span-4">
            <p className={`text-base md:text-lg leading-relaxed ${dark ? "text-white/80" : "text-[#3a4a4a]"}`}>
              {intro}
            </p>
          </div>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
